import { createAction, type QueuedAction } from "@/v2/hooks/useActionQueue";
import { apiCall, refreshBoth, type ActionDeps } from "./types";

export function resolveFeedbackAction(entryId: number, deps: ActionDeps): QueuedAction {
	// attorney_feedback / needs_improvement live on the legacy entry shape only
	// (v2 hasn't surfaced them yet), so no v2 optimistic mirror is meaningful
	// here. The refresh still touches both stores so the legacy view rehydrates.
	const rollback = deps.updateEntries((prev) =>
		prev.map((e) =>
			e.id === entryId ? { ...e, attorney_feedback: null, needs_improvement: false } : e,
		),
	);

	return createAction({
		execute: () =>
			apiCall(deps, {
				endpoint: `/records/${entryId}/resolve-feedback`,
				method: "POST",
			}),
		rollback,
		toast: {
			loading: "Resolving feedback…",
			success: "Feedback resolved",
			error: "Failed to resolve feedback",
		},
		onSuccess: () => refreshBoth(deps),
		onError: () => refreshBoth(deps),
	});
}
